export default __webpack_public_path__ + "static/media/alebeltrame.b7ae172e.png";